import React, { useState } from "react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import { Inbox, Mail, MailOpen, Star } from "lucide-react";
import InboxTab from "./components/InboxTab";
import { MESSAGES as initialMessages } from "./components/messageData";

const ClientInbox = () => {
  const [messages, setMessages] = useState(initialMessages);
  const [starredMessages, setStarredMessages] = useState({});

  const toggleStar = (id) => {
    setStarredMessages((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const markAsRead = (message) => {
    setMessages((prev) =>
      prev.map((m) =>
        m.id === message.id ? { ...m, isRead: true } : m
      )
    );
  };

  const totalCount = messages.length;
  const unreadCount = messages.filter((m) => !m.isRead).length;
  const starredCount = Object.values(starredMessages).filter(Boolean).length;

  return (
    <div className="space-y-6">
      <SummaryHeader
        title="Communications Center"
        icon={Inbox}
        color="blue-purple"
        description="Announcements and updates from Hyvid"
      >
        <div className="summary-item-container">
          <SummaryItem
            title="Total Messages"
            icon={<Mail className="w-4 h-4" />}
            display={totalCount}
          />
          <SummaryItem
            title="Unread"
            icon={<MailOpen className="w-4 h-4" />}
            display={unreadCount}
          />
          <SummaryItem
            title="Starred"
            icon={<Star className="w-4 h-4" />}
            display={starredCount}
          />
        </div>
      </SummaryHeader>

      <InboxTab
        messages={messages}              
        starredMessages={starredMessages}  
        toggleStar={toggleStar}
        onSelectMessage={markAsRead}     
      />
    </div>
  );
};

export default ClientInbox;
